module.exports = __webpack_public_path__ + "static/media/oatmeal-raisin.6d474ba1.png";